import MasterCrudPage from '../../components/MasterCrudPage';

export default function EducationLevels() {
  return (
    <MasterCrudPage
      config={{
        title: 'Education',
        apiBase: '/payroll/masters/education-levels',
        listKey: 'educationLevels',
        entityKey: 'educationLevel',
        fields: [
          { key: 'classificationGroup', label: 'Classification Group', type: 'text', maxLength: 50 },
          { key: 'classificationSubgroup', label: 'Classification Sub-group', type: 'text', maxLength: 50 },
        ],
        bare: true,
      }}
    />
  );
}
